import Api from '@cabinet/services'

export default {
  getManual() {
    return Api().get(`/questions/`)
  }
}
